import styled from 'styled-components';

export const Section = styled.section`
	margin-top: -63px;
	padding-top: 0;
	padding-bottom: 0;
`;
